import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { LegendBtnConfig } from '../../legend/LegendButtons';
import { ButtonType } from '../../legend/ButtonType';

@Component({
    selector: 'legend-button',
    templateUrl: './legend-button.component.html',
    styleUrls: ['./legend-button.component.scss']
})
export class LegendButtonComponent {
    @Input() buttonConfig: LegendBtnConfig;

    @Input() disabled: boolean;

    @Output() buttonClick: EventEmitter<LegendBtnConfig> = new EventEmitter<LegendBtnConfig>();

    onButtonClick(){
        if(!this.disabled){
            this.buttonClick.emit(this.buttonConfig);
        }
    }

    getTranslationLabel(btnType: ButtonType): string {
        if(btnType === 'type1' ){
            return 'XAll'
        }
        if(btnType === 'type2' ){
            return 'XSelected'
        }
    }

}
